import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ITHORBurnStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTSBurnStatsConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorswap', 'thor_burn_stats', timeframe)) as ITHORBurnStats[]

	const series1 = chartData.map((element: ITHORBurnStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.THOR_BURNED }
	})
	const series2 = chartData.map((element: ITHORBurnStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.THOR_BURNED_CUMULATIVE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'THOR burned',
			type: 'bars',
			seriesGroup: '[thor]',
			color: 'green',
			unitSymbol: ''
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'cumulative',
			type: 'line',
			seriesGroup: ' [thor]',
			color: 'orange',
			unitSymbol: ''
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const TSBurnStats = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTSBurnStatsConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="THOR Burn Stats"
			chartDesc="Cumulative amount of THOR that has been burned."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="36b3b6b9-9e9c-4eef-a42f-a31fe7af0775"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default TSBurnStats
